var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#767571",
  strokeWidth: 2,
  d: "m6.047 7.824-.001-.002-3.08-2.738A5.87 5.87 0 0 1 1.008 1h15.98a5.87 5.87 0 0 1-1.96 4.084L11.952 7.82a3.5 3.5 0 0 0-1.175 2.618v3.933l-3.556 2.37v-6.303a3.5 3.5 0 0 0-1.173-2.615Z"
})));
export default SvgFilter;